import { render, staticRenderFns } from "./CompanyForgetPassword.vue?vue&type=template&id=23728c72&scoped=true&"
import script from "../../services/company/company-forget-password.js?vue&type=script&lang=js&"
export * from "../../services/company/company-forget-password.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/company.css?vue&type=style&index=0&id=23728c72&scoped=true&lang=css&"
import style1 from "./CompanyForgetPassword.vue?vue&type=style&index=1&id=23728c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23728c72",
  null
  
)

export default component.exports